module.exports = __webpack_public_path__ + "img/4.523faf19.jpg";